module.exports = __webpack_public_path__ + "static/media/thermometer-quarter.bf1bc994.svg";